import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export function LoadingState(): JSX.Element {
	return <Loader size="m" mx="auto" my={24} />;
}
